export default function containsNumber(value) {
    var NUMBER = /[0-9]/;
    return NUMBER.test(value);
}
